import React, { useState } from 'react';

import LogoutModal from 'components/pages/settings/LogoutModal';
import DeleteAccountModal from 'components/pages/settings/DeleteAccountModal';
import PasswordSection from 'components/pages/settings/PasswordSection';
import UserFullName from 'components/common/userfullname/UserFullName';
import Modal from '@core/components/Modal/Modal';
import Spinner from '@core/components/spinner/Spinner';
import ProfileInfo from 'components/pages/settings/profileinfo/ProfileInfo';
import ContactForm from 'components/pages/settings/contactform/ContactForm';
import InterestsForm from 'components/pages/settings/interestsform/InterestsForm';
import JobForm from 'components/pages/settings/jobform/JobForm';

import UseModal from 'hooks/use-modal';
import useWindowSize from 'hooks/use-windowSize';

import { countries } from 'country-flags-svg';

import { MOBILE_SLIDE_UP, MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import LogoutIcon from 'assets/icons/logout-icon.svg';
import AccountIcon from 'assets/icons/red-account-icon.svg';
import PasswordIcon from 'assets/icons/change-password-icon.svg';
import EditNameIcon from 'assets/icons/name-edit-icon.svg';
import { Edit } from 'iconsax-react';

import CareerBanner from 'components/pages/settings/account/CareerBanner/CareerBanner';
import classes from './AccountInfo.module.scss';

const AccountInfo = ({ data, refetch, toast }) => {

    const { mobileDevice } = useWindowSize();
    const [activeTab, setActiveTab] = useState('myAccount');

    const {
        showModal: showLogoutModal,
        destroyModal: destroyLogoutModal,
        show: showLogout
    } = UseModal();
    const {
        showModal: showDeleteAccountModal,
        destroyModal: destoryDeleteAccountModal,
        show: showDeleteAccount
    } = UseModal();
    const {
        showModal: showChangePasswordHandler,
        destroyModal: destoryChangePassword,
        show: showChangePasswordModal
    } = UseModal();
    const {
        showModal: showFullNameHandler,
        destroyModal: destoryFullName,
        show: showFullNameModal
    } = UseModal();
    const {
        showModal: showContactModal,
        destroyModal: destoryContactModal,
        show: showContact
    } = UseModal();
    const {
        showModal: showInterestsModal,
        destroyModal: destoryInterestsModal,
        show: showInterests
    } = UseModal();
    const {
        showModal: showModalJob,
        destroyModal: destroyModalJob,
        show: showJob
    } = UseModal();

    const showDeleteSection = () => {
        if (mobileDevice) {
            showDeleteAccountModal();
        } else {
            setActiveTab('delete-account');
        }
    };

    const hideDeleteSection = () => {
        if (mobileDevice) {
            destoryDeleteAccountModal();
        } else {
            setActiveTab('myAccount');
        }
    };


    return (
        <>
            {data ? (
                <>
                    {activeTab == 'myAccount' ? (
                        <div className={`${classes['my-account-wrapper']}`}>
                            <div className={classes['account-actions']}>
                                <ul className={`d-flex flex-column ${classes['user-info-section']}`}>
                                    <li className='d-flex justify-content-between align-items-center'>
                                        <div className="d-flex flex-column flex-md-row align-items-md-center">
                                            <h4>About</h4>
                                        </div>
                                        {data.data.is_verified && (
                                            <Edit role="button" onClick={() => showModalJob()} size={24} color='#BB3A90' variant='TwoTone' />
                                        )}
                                    </li>
                                    <li className="d-flex flex-column flex-md-row align-items-md-center">
                                        <p className="mb-2 mb-md-0">Job Role: </p>
                                        <span>{data.data.job_role ? data.data.job_role : '-'}</span>
                                    </li>
                                    <li className="d-flex flex-column flex-md-row align-items-md-center">
                                        <p className="mb-2 mb-md-0">Experience: </p>
                                        <span>{data.data.years_of_experience_label ? `${data.data.years_of_experience_label}` : '-'}</span>
                                    </li>
                                    <li>
                                        <CareerBanner />
                                    </li>
                                </ul>                                
                                <button onClick={showLogoutModal} className={classes['action']}>
                                    <LogoutIcon />
                                    <span>Logout</span>
                                </button>
                                {!data?.data.is_oauth && (
                                    <button onClick={showChangePasswordHandler} className={classes['action']}>
                                        <PasswordIcon />
                                        <span>Change Password</span>
                                    </button>
                                )}
                                <button onClick={showDeleteSection} className={classes['action']}>
                                    <AccountIcon />
                                    <span>Delete account</span>
                                </button>
                            </div>
                        </div>
                    ) : (
                        <DeleteAccountModal closeModal={hideDeleteSection} />
                    )}
                    <Modal show={showFullNameModal} closeHandler={destoryFullName} type={MOBILE_SLIDE_UP}>
                        <UserFullName
                            title="Add Your Name"
                            description="Please note that your name is not editable later"
                            callback={() => {
                                refetch();
                                destoryFullName();
                            }}
                        />
                    </Modal>
                    <Modal
                        title="Delete Account"
                        show={showDeleteAccount}
                        type={MOBILE_FULLSCREEN}
                        closeHandler={destoryDeleteAccountModal}>
                        <DeleteAccountModal closeModal={destoryDeleteAccountModal} />
                    </Modal>
                    <Modal header={false} show={showLogout} closeHandler={destroyLogoutModal}>
                        <LogoutModal closeModal={destroyLogoutModal} />
                    </Modal>
                    <Modal
                        title="Change Password"
                        show={showChangePasswordModal}
                        closeHandler={destoryChangePassword}
                        type={MOBILE_SLIDE_UP}>
                        <PasswordSection callback={destoryChangePassword} />
                    </Modal>
                    <Modal
                        show={showContact}
                        closeHandler={destoryContactModal}
                        type={MOBILE_SLIDE_UP}>
                        <ContactForm closeHandler={destoryContactModal} refetchHandler={refetch} toast={toast} />
                    </Modal>
                    <Modal
                        show={showInterests}
                        closeHandler={destoryInterestsModal}
                        type={MOBILE_SLIDE_UP}>
                        <InterestsForm closeHandler={destoryInterestsModal} refetchHandler={refetch} toast={toast} />
                    </Modal>
                    <Modal show={showJob} closeHandler={destroyModalJob} type={MOBILE_FULLSCREEN}>
                        <JobForm closeHandler={destroyModalJob} refetchHandler={refetch} toast={toast} />
                    </Modal>
                </>
            ) : (
                <div className="d-flex align-items-center justify-content-center w-100 py-5">
                    <Spinner />
                </div>
            )}

        </>
    );
};

export default AccountInfo;